import {Component, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CodaltComponent} from '../../codalt.component';
import {Checkpoint} from '../../classes/checkpoint';
import {CheckpointService} from '../../services/checkpoint.service';
import {Platform} from '../../classes/platform';
import {CheckpointResult} from '../../classes/checkpoint-result';
import {PlatformService} from '../../services/platform.service';
import {DatePipe} from '@angular/common';
import {CheckpointResultLevelStatusPipe} from '../../pipes/checkpoint-result-level-status.pipe';
import {CheckpointResultService} from '../../services/checkpoint-result.service';
import {BreadcrumbComponent} from '../../services/breadcrumb/breadcrumb.component';
import {Routenames} from '../../classes/route-name.enum';
import {FormatResponseTextPipe} from '../../pipes/format-response-text.pipe';
import {CheckpointHeaderComponent} from '../../services/checkpoint-header/checkpoint-header.component';
import {BytesPipePipe} from '../../pipes/bytes.pipe';
import {CurlErrorCodesEnum} from '../../classes/curl-error-codes.enum';
import {Title} from '@angular/platform-browser';

// for error references look at the following website : https://curl.se/libcurl/c/libcurl-errors.html
@Component({
    selector: 'app-checkpoint',
    templateUrl: './checkpoint-result-overview.component.html',
    styleUrls: ['./checkpoint-result-overview.component.scss'],
    imports: [
        DatePipe,
        CheckpointResultLevelStatusPipe,
        BreadcrumbComponent,
        FormatResponseTextPipe,
        CheckpointHeaderComponent,
        BytesPipePipe,
    ]
})
export class CheckpointResultOverviewComponent extends CodaltComponent implements OnInit {
    readonly checkpointResult = signal<CheckpointResult>(new CheckpointResult());

    readonly platform = signal<Platform>(new Platform());
    readonly checkpoint = signal<Checkpoint>(new Checkpoint());

    readonly minRespTime: string = 'Minimal responseTime threshold breached';
    readonly maxRespTime: string = 'Maximum responseTime threshold breached';
    readonly minContSize: string = 'Minimal content size threshold breached';
    readonly maxContSize: string = 'Maximum content size threshold breached';
    readonly checksumMismatch: string = 'Checksum mismatch';

    readonly CurlErrorCodesEnum = CurlErrorCodesEnum;

    constructor(
        private activatedRoute: ActivatedRoute,
        private checkpointResultService: CheckpointResultService,
        private checkpointService: CheckpointService,
        private platformService: PlatformService,
        private titleService: Title,
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.activatedRoute.params.subscribe((params: { platformId, checkId, checkResultId }) => {

                this.subscriptions.add(
                    this.platformService.getSingle(+params.platformId, 'platformId').subscribe({
                        next: platform => {
                            this.platform.update(() => platform)
                            this.setCrumbs();
                            this.titleService.setTitle(`${this.platform().name} - Seire ${this.environment.titleAppend}`);
                        },
                        error: err => console.error(err)
                    })
                );
                this.subscriptions.add(
                    this.checkpointService.getSingle(+params.checkId, 'checkpointId').subscribe({
                        next: checkpoint => {
                            this.checkpoint.set({...checkpoint})
                            this.setCrumbs();
                        },
                        error: err => console.error(err)
                    })
                );

                this.subscriptions.add(
                    this.checkpointResultService.getCheckpointResult(+params.checkResultId).subscribe({
                        next: (responseResult) => {
                            this.checkpointResult.set(responseResult);
                            this.setCrumbs();

                            if (this.checkpointResult().hash !== null) {
                                this.subscriptions.add(
                                    this.checkpointResultService.getCheckpointResultContent(this.checkpointResult().hash).subscribe({
                                        next: (checkpointResultContent) => {
                                            this.checkpointResult.update(checkpointResult => ({...checkpointResult, checkpoint_results_content: checkpointResultContent}));
                                            this.setCrumbs();
                                        },
                                        error: err => console.error(err)
                                    })
                                );
                            }
                        },
                        error: err => console.error(err)
                    })
                );
                this.subscriptions.add(
                    this.checkpointResultService.getSingle(+params.checkResultId, 'checkpointResultId').subscribe({
                        next: (responseResult) => {
                            if (this.checkpointResult().id !== responseResult.id) {
                                return;
                            }
                            this.checkpointResult.update(() => responseResult);
                        },
                        error: err => console.error(err)
                    })
                );
            })
        );
    }

    setCrumbs() {
        this.crumbs = [
            {name: 'Seire', route: Routenames.seire},
            {name: `Platform : ${this.platform().name}`, route: `${Routenames.seire}/${this.platform().id}`},
            {name: `Checkpoint : ${this.checkpoint().name}`, route: `${Routenames.seire}/${this.platform().id}/overview/${this.checkpoint().id}`},
            {
                name: `Checkpoint resultaat : ${this.checkpointResult().id}`,
                route: `${Routenames.seire}/${this.platform().id}/overview/${this.checkpoint().id}/${this.checkpointResult().id}`
            }
        ];
    }
}
